<template>
  <div class="admin_bracket_roundRobin">
    <div class="actions">
      <button v-if="!publishedPhaseTwo" class="add" @click="addBracket"><i class="fas fa-plus"></i></button>
      <button v-if="allEditable" class="split" @click="splitTeams">Automaticky rozdělit týmy</button>
      <button v-if="phase == 1" class="copy" @click="copyMatcheFromPhase0">Doplnit zápasy ze základních skupin</button>
      <button class="publish" @click="publish">{{ allPublished ? "Zrušit zveřejnění" : "Zveřejnit všechny skupiny" }}</button>
      <button v-if="!publishedPhaseTwo" class="advance" @click="advance">Přepočítat postupující týmy</button>
      <button class="export" @click="exportCategory">Export</button>
      <button class="export" @click="exportCategoryToExcel">Export to excel</button>
      <span class="count">Celkem zápasů: {{ categoryMatchesCount }}</span>
    </div>
    <div v-if="!allPublished && !publishedPhaseTwo" class="freeTeams" @dragover="droppable($event, draggedTeamData != null)" @drop="drop(null)">
      <span v-for="team in freeTeams" :key="team.id" class="team" draggable="true" @dragstart="dragstart(team.id, null)">{{ team.id | team_name_short }}</span>
      <span v-if="!anyFreeTeams" class="none">Žádný volný tým</span>
    </div>
    <div v-for="(bracket, id) in bracketsExtended" :key="id" class="bracket" @dragover="droppable($event, bracket.editable)" @drop="drop(bracket)">
      <div class="row">
        <label :for="`name-${id}`">Název skupiny:</label>
        <inputer :paths="['brackets', id, 'name']" :id="`name-${id}`" :disabled="!bracket.editable" name="Název skupiny" />

        <div class="actions">
          <button class="publish" @click="publishBracket(bracket)">{{ bracket.published ? "Zrušit zveřejnění" : "Zveřejnit" }}</button>
          <button v-if="bracket.editable" class="remove" @click="removeBracket(id)"><i class="fas fa-times"></i></button>
          <button class="export" @click="exportPdf(bracket)">Export</button>
        </div>
      </div>
      <div class="row">
        <label :for="`advancingCount-${id}`">Počet postupujících:</label>
        <inputerNumber :paths="['brackets', id, 'advancingCount']" :id="`advancingCount-${id}`" :min="0" :max="bracketTeamsCount[id] != null ? bracketTeamsCount[id] : 0" :disabled="!bracket.editable" name="Počet postupujících" />
      </div>
      <div class="row">
        <label :for="`setField-${id}`">Hřiště:</label>
        <inputerSelect :paths="['brackets', id, 'fieldId']" :id="`setField-${id}`" :items="fields" name="Hřiště">
          <template v-slot:default="{ item }">{{ item != null ? item.name : "Zvolte hřiště" }}</template>
          <template v-slot:item="{ item }">{{ item.name }}</template>
        </inputerSelect>
      </div>
      <roundRobinTable :bracket="bracket" @teamDragged="dragstart" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { _ } from "../../../extend";
import { data } from "../../../store_utils";
import { cz_short } from "../../../filters";
import inputer from "../../../components/inputer";
import inputerNumber from "../../../components/inputer-number";
import inputerSelect from "../../../components/inputer-select";
import roundRobinTable from "./bracket_roundRobin_table.vue";

export default {
  name: "bracket_roundRobin",
  components: {
    inputer,
    inputerNumber,
    inputerSelect,
    roundRobinTable,
  },
  props: {
    brackets: {},
    category: {},
    phase: {},
  },
  data: () => ({
    draggedTeamData: null,
    bracketsToExport: {},
  }),
  computed: {
    ...mapState(['fields']),
    ...mapGetters(['bracketTeamsCount']),
    bracketsExtended() {
      return _.select(this.brackets, b => ({
        ...b,
        editable: !b.published && !this.publishedPhaseTwo,
      }));
    },
    categoryTeams() {
      if (this.phase == 0)
        return _.filter(this.$store.state.teams, team => team.id.split('-')[0] == this.category);

      var previousBrackets = _.filter(this.$store.state.brackets, b => b.categoryId == this.category && b.phase == this.phase - 1);
      var advancingCount = _.sum(previousBrackets, b => b.advancingCount);
      return [...Array(advancingCount).keys()]
        .map(index => ({ id: `ADVANCING-${`${(index + 1)}`.padStart(2, '0')}`, advancingOrder: index, label: `${index + 1}. místo`}));
    },
    freeTeams() {
      if (this.phase == 0)
        return _.filter(this.categoryTeams, t => _.all(this.$store.state.bracketTeams, bt => bt.teamId != t.id));

      var currentCategoryPhaseTeams = _.filter(this.$store.state.bracketTeams, bt => _.any(this.brackets, b => bt.bracketId == b.id));
      return _.filter(this.categoryTeams, t => _.all(currentCategoryPhaseTeams, bt => bt.advancingOrder != t.advancingOrder))
    },
    anyFreeTeams() {
      return _.count(this.freeTeams) > 0;
    },
    allEditable() {
      return _.all(this.bracketsExtended, b => b.editable, false);
    },
    allPublished() {
      return _.all(this.brackets, b => b.published, false);
    },
    publishedPhaseTwo() {
      var phaseTwoBrackets = _.filter(this.$store.state.brackets, b => b.phase > this.phase && b.categoryId == this.category);
      return _.all(phaseTwoBrackets, b => b.published);
    },
    categoryMatchesCount() {
      return _.count(this.$store.state.matches, m => this.brackets[m.bracketId] != null);
    },
  },
  methods: {
    addBracket() {
      const order = _.max(this.brackets, bracket => bracket.order) + 1;
      const letter = String.fromCharCode(64 + order);
      const newBracket = {
        id: data.newGuid(),
        name: `${cz_short[this.category]}${this.phase == 1 ? " postup" : ""} ${letter}`,
        type: 'RoundRobin',
        categoryId: this.category,
        order,
        phase: this.phase,
        advancingCount: 0,
        published: false,
        fieldId: null,
      };
      this.$store.commit("add", {
        paths: ["brackets", newBracket.id],
        value: newBracket,
      });
    },
    removeBracket(bracketId) {
      // bracket
      this.$store.commit('remove', {
        paths: ["brackets", bracketId]
      });
      // bracketTeams
      var bracketTeams = _.filter(this.$store.state.bracketTeams, bt => bt.bracketId == bracketId);
      _.forEach(bracketTeams, bt => this.$store.commit('remove', { paths: ['bracketTeams', bt.id] }));
      // matches
      var matches = _.filter(this.$store.state.matches, m => m.bracketId == bracketId);
      _.forEach(matches, m => this.$store.commit('remove', { paths: ['matches', m.id] }));
    },
    publishBracket(bracket) {
      if (!bracket.published && !confirm("Opravdu chcete tuto skupinu zveřejnit? Zároveň se uloží všechny změny."))
        return;

      this.$store.commit("update", {
        paths: ["brackets", bracket.id, 'published'],
        value: !bracket.published,
      });
      this.$store.dispatch('save');
    },
    splitTeams() {
      const bracketCount = _.count(this.brackets);
      const groupedByOutpost = _.groupBy(this.categoryTeams, team => team.outpostId);

      // fill
      let bracketI = 0;
      let bracketTeams = _.select(this.brackets, () => []);
      _.forEach(groupedByOutpost, teams => {
        _.forEach(teams, team => {
          let bracket = this.brackets[Object.keys(this.brackets)[bracketI]];
          bracketTeams[bracket.id].push(team.id);
          bracketI = (bracketI + 1) % bracketCount;
        });
      });

      // generate matches
      _.forEach(this.brackets, bracket => {
        this.$store.dispatch('generateRoundRobinMatches', { bracket, teamIds: bracketTeams[bracket.id] });
      });
    },
    advance() {
      this.$store.dispatch('advance', { categoryId: this.category, phase: this.phase });
    },
    copyMatcheFromPhase0() {
      this.$store.dispatch('copyMatcheFromPhase0', { categoryId: this.category });
    },
    publish() {
      var publish = !this.allPublished;
      if (publish && !confirm("Opravdu chcete všechny skupiny zveřejnit? Zároveň se uloží všechny změny."))
        return;

      _.forEach(this.brackets, b => {
        this.$store.commit("update", {
          paths: ["brackets", b.id, "published"],
          value: publish,
        });
      })
      this.$store.dispatch('save');
    },
    async exportPdf(bracket) {
      this.$store.dispatch('exportTournamentPdf', { bracketId: bracket.id });
    },
    async exportCategory() {
      this.$store.dispatch('exportTournamentPdf', { categoryId: this.category });
    },
    exportCategoryToExcel() {
      this.$store.dispatch('exportTournament', {
        categoryId: this.category,
      });
    },

    dragstart(teamId, bracketId) {
      this.draggedTeamData = { teamId, bracketId };
    },
    droppable(ev, canDrop) {
      if (canDrop && !this.publishedPhaseTwo) {
        ev.preventDefault();
      }
    },
    // move team
    drop(finalBracket) {
      if (this.draggedTeamData == null || (finalBracket != null && finalBracket.id == this.draggedTeamData.bracketId)) {
        return;
      }

      const prevBracket = this.brackets[this.draggedTeamData.bracketId];
      if (prevBracket != null) {
        if (prevBracket.advancingCount >= this.bracketTeamsCount[prevBracket.id]) {
          this.$store.commit('update', {
            paths: ['brackets', prevBracket.id, 'advancingCount'],
            value: this.bracketTeamsCount[prevBracket.id] - 1,
          });
        }

        var teamIds = Object.values(this.$store.state.bracketTeams)
          .filter(bt => bt.bracketId == prevBracket.id)
          .filter(bt => bt.teamId != this.draggedTeamData.teamId)
          .map(bt => bt.teamId);
        this.$store.dispatch('generateRoundRobinMatches', { bracket: prevBracket, teamIds });
      }

      if (finalBracket != null) {
        var teamIds = Object.values(this.$store.state.bracketTeams)
          .filter(bt => bt.bracketId == finalBracket.id)
          .map(bt => bt.teamId);
        teamIds.push(this.draggedTeamData.teamId);
        this.$store.dispatch('generateRoundRobinMatches', { bracket: finalBracket, teamIds });
      }

      this.draggedTeamData = null;
    },
  },
}
</script>

<style lang="sass">
@import "../../../sass/_constants.sass"
@import "../../../sass/_components.sass"

.admin_bracket_roundRobin
  .freeTeams
    display: grid
    grid-auto-flow: column
    grid-gap: .3rem
    justify-content: center
    overflow-y: auto

    .team
      padding: .3rem .5rem
      border-radius: .5rem
      color: $c-secondary
      background-color: $bc-secondary
      cursor: pointer
    .none
      color: $c-secondary
      overflow: hidden
  .add
    @include button-primary()
  .split
    @include button-secondary()
  .advance
    @include button-secondary()
  .copy
    @include button-secondary()
  .export
    @include button-secondary()
  .publish
    @include button-warning()
  .bracket
    display: grid
    padding: 1rem
    grid-gap: 1rem
    border-radius: 1rem
    box-shadow: 0px 0px 3px $c-default
    &:hover
      box-shadow: 0px 0px 5px $c-default
    &:not(:last-child)
      margin-bottom: 2rem
      border-bottom: 3px solid transparent
    .row
      display: grid
      grid-auto-flow: column
      grid-template-columns: max-content 1fr max-content
      grid-gap: 1rem
      align-items: center
    .remove
      @include button-danger()
  .actions
    .count
      @include button-secondary()
      cursor: inherit
    & > *
      &:not(:first-child):last-child
        @include last-input()
      &:not(:last-child):first-child
        @include first-input()
      &:not(:first-child):not(:last-child)
        @include middle-input()
</style>